var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechTextContainerNoSides(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 833.2412,
    height: 369.6276,
    viewBox: "0 0 833.2412 369.6276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.8949,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.8949,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.2579,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.2579,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.6208,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.6208,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.0012,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.0012,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.3505,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.3505,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.7,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.7,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.1273,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.1273,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.4757,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.4757,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.8744,
    cy: 4.6667,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.8744,
    cy: 364.9609,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5874,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5874,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.9609,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.9609,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.3342,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.3342,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.7077,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.7077,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.081,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.081,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.4545,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.4545,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.8278,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.8278,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 737.2013,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 737.2013,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.5745,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828.5745,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.6667,
    cy: 338.6559,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.6667,
    cy: 30.7833,
    r: 4.6667,
    fill: "#3b3b39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "737.165 338.656 782.852 365.033 828.539 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "737.165 30.783 691.479 4.406 645.792 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "828.561 30.783 782.875 4.406 737.188 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "645.792 338.656 691.479 365.033 737.165 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "645.792 30.783 600.105 4.406 554.418 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "554.418 338.656 600.105 365.033 645.792 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "554.418 30.783 508.732 4.406 463.045 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "463.045 338.656 508.732 365.033 554.418 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "371.671 30.783 325.985 4.406 280.298 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "280.298 338.656 325.985 365.033 371.671 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "280.298 30.783 234.611 4.406 188.925 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.925 338.656 234.611 365.033 280.298 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.178 338.656 51.864 365.033 97.551 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8641,4.406",
    transform: "translate(-0.0001)",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5511,30.783",
    transform: "translate(-0.0001)",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "463.045 30.783 417.358 4.406 371.671 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "371.671 338.656 417.358 365.033 463.045 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.925 30.783 143.238 4.406 97.551 30.783",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.582 30.806 51.895 4.429 6.208 30.806",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.551 338.656 143.238 365.033 188.925 338.656",
    fill: "none",
    stroke: "#3b3b39",
    strokeMiterlimit: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechTextContainerNoSides);
export default __webpack_public_path__ + "static/media/tech-text-container-no-sides.f047391abe50372877fb3177eb1a05d1.svg";
export { ForwardRef as ReactComponent };